import React from 'react';
import * as R from 'ramda';
import { withFormik } from 'formik';
import { pure, compose, withState, withHandlers } from 'react-recompose';
// components
import { FormFooter } from '../../../components/form-footer';
// helpers/constants
import * as G from '../../../helpers';
import * as GC from '../../../constants';
// hocs
import { withComponentDidUpdatePropCallback } from '../../../hocs';
// forms
import { Fieldset2 } from '../../../forms';
// ui
import { Flex, ModalActionButton, ModalCancelButton } from '../../../ui';
// feature new-import
import * as C from '../constants';
import { withAsyncGetMatchedFields } from '../hocs';
import { matchFields, importFileField } from '../settings';
//////////////////////////////////////////////////

const enhance = compose(
  withState('matchedOptions', 'setMatchedOptions', []),
  withState('defaultFields', 'setDefaultFields', { [GC.FIELD_DOCUMENT_UPLOAD]: null }),
  withAsyncGetMatchedFields,
  withFormik({
    enableReinitialize: true,
    mapPropsToValues: ({ defaultFields, initialValues }) => G.setInitialFormikValues(
      defaultFields,
      initialValues,
    ),
    handleSubmit: (values, { props }) => {
      const {
        source,
        importType,
        submitAction,
        contractGuid,
        selectedRoles,
        matchedFields,
        currentBranchGuid } = props;

      const matchedFieldsFromValues = R.compose(
        R.values,
        R.mapObjIndexed((value, key) => ({ name: key, matchedField: value })),
      )(values);
      const addIndexToMatchedFields = R.map((field) => {
        let matchedField = field;
        R.forEach((item) => {
          if (R.equals(field.name, item.name)) return matchedField = R.assoc('index', item.index, field);
        }, R.pathOr([], ['headers'], matchedFields));

        return matchedField;
      }, matchedFieldsFromValues);
      let data = {
        contractGuid,
        type: importType,
        uri: matchedFields.uri,
        branchGuid: currentBranchGuid,
        matchFields: addIndexToMatchedFields,
      };
      const roleGuids = R.map((item) => item.value, R.or(selectedRoles, []));
      if (R.and(R.equals(importType, C.IMPORT_TYPE_DRIVER), G.isNotNilAndNotEmpty(roleGuids))) {
        const parameters = { roleGuids };

        data = R.assoc('parameters', parameters, data);
      }
      if (R.includes(importType, [C.IMPORT_TYPE_TOLL_CHARGE, C.IMPORT_TYPE_FUEL_CARD_TRANSACTION])) {
        const parameters = { source };

        data = R.assoc('parameters', parameters, data);
      }

      submitAction(data);
    },
  }),
  withHandlers({
    handleCustomChange: ({ values, setValues }) => (event) => {
      const fieldWithDots = {
        [event.currentTarget.id]: R.path(['currentTarget', 'value'], event),
      };

      setValues(R.mergeRight(values, fieldWithDots));
    },
    handleCloseMapAndImport: ({ matchedFields, removeMapAndImportFileRequest }) => () => {
      const data = { uri: matchedFields.uri };

      removeMapAndImportFileRequest(data);
    },
    handleDisableMatchedOptions: ({ values, matchedOptions, setMatchedOptions }) => () => {
      const filtered = R.filter(G.isNotEmpty, R.values(values));
      const options = R.map((item) => {
        const { value } = item;

        if (R.includes(value, filtered)) return R.assoc('disabled', true, item);

        return R.assoc('disabled', false, item);
      }, matchedOptions);

      return setMatchedOptions(options);
    },
  }),
  withComponentDidUpdatePropCallback({
    propName: 'values',
    callbackName: 'handleDisableMatchedOptions',
  }),
  pure,
);

export const MapAndImport = (props) => {
  const {
    values,
    closeModal,
    importType,
    handleSubmit,
    matchedFields,
    matchedOptions,
    handleGetMatchedFields,
    handleCloseMapAndImport,
  } = props;

  const options = R.map(R.prop(GC.FIELD_VALUE), R.or(matchedOptions, []));

  const fieldsWithMatchedOptions = R.compose(
    R.map(({ name }) => ({
      fieldsWrapperStyles: { mb: 10, justifyContent: 'space-between' },
      fields: [
        {
          type: 'customComponent',
          Component: () => <Flex width={200}>{name}</Flex>,
        },
        matchFields(name),
      ],
    })),
    R.filter(({ matchedField }) => G.notContain(matchedField, options)),
    R.pathOr([], ['headers']),
  )(matchedFields);

  const data = {
    type: importType,
    file: R.prop(GC.FIELD_DOCUMENT_UPLOAD, values),
  };

  const withMatchedFields = G.isNotNilAndNotEmpty(matchedFields);

  return (
    <form onSubmit={handleSubmit}>
      <Flex
        alignItems='flex-start'
        flexDirection={G.ifElse(withMatchedFields, 'row', 'column')}
      >
        <Fieldset2
          {...G.getFormikProps(props)}
          fieldsWrapperStyles={{ pt: 10 }}
          fields={R.of(Array, importFileField)}
        />
        <Flex width='100%' justifyContent='space-between' mt={G.ifElse(withMatchedFields, 15)}>
          <ModalCancelButton
            m='5px'
            type='button'
            onClick={closeModal}
            display={G.ifElse(withMatchedFields, 'none', 'block')}
          >
            {G.getWindowLocale('actions:cancel', 'Cancel')}
          </ModalCancelButton>
          <ModalActionButton
            m='5px'
            type='button'
            onClick={() => handleGetMatchedFields(data)}
            disabled={G.isNilOrEmpty(R.path([GC.FIELD_DOCUMENT_UPLOAD, GC.FIELD_NAME], values))}
          >
            {G.getWindowLocale('actions:upload', 'Upload')}
          </ModalActionButton>
        </Flex>
      </Flex>
      {
        withMatchedFields &&
        <Flex flexDirection='column'>
          <Fieldset2
            {...G.getFormikProps(props)}
            grouped={true}
            matchedOptions={matchedOptions}
            fields={fieldsWithMatchedOptions}
            fieldsWrapperStyles={{ pt: 10, flexDirection: 'column' }}
          />
          <FormFooter
            closeModal={handleCloseMapAndImport}
            submitBtnText={G.getWindowLocale('actions:send', 'Send')}
          />
        </Flex>
      }
    </form>
  );
};

export default enhance(MapAndImport);
